__turbopack_context__.v({
  "className": "nunito_sans_3d0ab3ad-module__G_5Mga__className",
});
